// (function () {
//     'use strict';

//     const module = angular.module('imApp');

//     module.component('customerPersons', {
//         templateUrl: 'views/components/views/customerPersons/customerPersons.template.html?v=' + module.version,
//         controllerAs: 'vm',
//         controller: ['$stateParams', 'stateService', 'customerPersonsService', 'economyService', function ($stateParams, stateService, customerPersonsService, economyService) {
//             const vm = this;
//             let custNo = $stateParams.cust_no;
            
//             vm.model = {
//                 setting: {},
//                 itemsListCustomerPersons: []
//             };
            
//             async function loadSetting() {
//                 vm.model.setting = (await customerPersonsService.getCustomerPersons({ cust_no: custNo }))[0];
//             }

//             async function loadCustomerPersons() {
//                 vm.model.itemsListCustomerPersons = await economyService.listCustomerPersons({ cust_no: custNo });
//             }

//             vm.goToFunc = function (state) {
//                 switch (state) {
//                     case 'person':
//                         stateService.go(state, {
//                             cust_no: custNo,
//                             pers_no: '0'
//                         });
//                         break;
//                     default:
//                         break;
//                 }
//             };

//             vm.$onInit = async function () {
//                 loadSetting();
//                 loadCustomerPersons();
//             }
//         }]
//     });
// })();
